import { oneOf } from "prop-types";
import * as Yup from "yup";

export const InputSchema = Yup.object().shape({
  value: Yup.string()
    .required("This field is required to send a message.")
    .min(10, "Minimum 10 characters or more is required.")
    .max(700, "Maximum 700 characters or less"),
});

export const OoaPcpSchema = Yup.object().shape({
  first_name: Yup.string().required("PCP's first name is required."),
  last_name: Yup.string().required("PCP's last name is required."),
  phone_number: Yup.string()
    .matches(
      new RegExp("[0-9]{10}"),
      "Phone number is not valid. Enter 10 digit phone number e.g. 7025334353."
    )
    .min(10, "Minimum 10 characters. Please enter 10 digit phone number e.g. 7025334353.")
    .max(10, "Maximum 10 character limit. Please enter 10 digit phone number e.g. 7025334353.")
    .required("PCP's practice phone number is required."),
  address: Yup.string(),
});
